import { oneMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import { getActiveLocaleSelector, getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { isConditionalFeature } from '@americanexpress/conditional-features';
import { MODULE_NAME } from '../constants/modules';
import { MEMBERSHIP_QUERY } from '../graphql/membership';
import { hasVacationRentalsRule } from '../constants/featureRulesConstants';
import { PERSONA_API_FF } from '../constants/oneXpConstants';
import { usePrefetchedFeatureFlagWithProperties } from './useFeatureFlagWithProperties';

export const loadMembershipDomain = (state) => async (dispatch) => {
  const isLoggedIn = getIsLoggedInSelector(state);
  const isVacationRentalsEnabledLocale = isConditionalFeature(hasVacationRentalsRule, state);
  const activeLocale = getActiveLocaleSelector(state);
  const hasPersona = usePrefetchedFeatureFlagWithProperties(PERSONA_API_FF, state);

  if (!isLoggedIn || (!isVacationRentalsEnabledLocale && !hasPersona)) return;

  const fetcherOpts = {
    reporting: {
      moduleID: MODULE_NAME,
      componentID: 'loadMembershipDomain',
      fetch: {
        activeLocale,
      },
    },
  };

  await dispatch(oneMembershipDomainFetchye(
    { query: MEMBERSHIP_QUERY },
    {},
    fetcherOpts
  ));
};
